<template>
    <Loading :isLoading="isLoading" />
</template>

<script>
import { reactive, toRefs, ref, inject } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import { useStore } from 'vuex';
import routeName from '@/router/constant.js';
import { postLoginNotify, postInitNotify, postStartNotify } from '@/apis/eNotifyPromo';
import aplCatlCode from '@/json/aplCatlCode';
export default {
    setup() {
        const $vfm = inject('$vfm');
        const store = useStore();
        const router = useRouter();
        const route = useRoute();

        const isLoading = ref(false);
        const users = reactive({
            no: '',
            birthday: '',
            visible: true,
            source: route?.query?.source ? route?.query?.source : 'OWS',
            uuid: '',
            isLogin: false,
            a2Apply: false,
            a2Url: '',
        });

        const openPopup = (errorMessage) => {
            store.dispatch('eNotify/clearMember');
            $vfm.show({
                component: 'DialogBase',
                params: {
                    title: '系統提示',
                    content: errorMessage || '系統忙碌中，請稍後再試',
                    confirmButton: '確認',
                    cancelButton: null,
                    closeicon: true,
                },
                on: {
                    confirm() {
                        if (users.a2Apply === true) {
                            window.location.href = users.a2Url;
                        } else {
                            $vfm.hide('DialogBase');
                        }
                    },
                    closed() {
                        $vfm.hide('DialogBase');
                    },
                }
            });
        };
        (() => {
            store.dispatch('permissions/clearAll');
        })();
        // 登入
        const login = () => {
            const data = {
                token: route.query.no
            };
            return postLoginNotify(data).then(res => {
                store.dispatch('eNotify/setMember', res.data);
                store.dispatch('permissions/setAuthExternal', 'Y');
                store.dispatch('permissions/setUserInfo', res.data);
                return true;
            }).catch(err => {
                console.log(err.data?.errorMessage);
                // users.a2Apply = err.data.a2Apply;
                // users.a2Url = err.data.a2Url;
                // openPopup(err.data?.errorMessage);
            });
        };

        // 重置交易項目取得transactionUniqueId
        const init = () => {
            return postInitNotify().then(res => {
                store.dispatch('permissions/setTransactionId', res.data.transactionUniqueId);
                store.dispatch('permissions/setAplCatl', aplCatlCode.E_NOTIFY_PROMO);
                return true;
            }).catch(err => {
                openPopup(err.data.errorMessage);
            });
        };

        const start = () => {
            return postStartNotify().then(res => {
                return true;
            }).catch((err) => {
                openPopup(err.data.errorMessage);
            });
        };

        /**
         * 打api
         * @param {Boolean} canPost 欄位檢查合格可以呼叫api
        */
        const postApi = async () => {
            isLoading.value = true;
            if (await login()) {
                // users.isLogin = true;
                if (await init()) {
                    if (await start()) {
                        goNextPage();
                    } else {
                        isLoading.value = false;
                    }
                } else {
                    isLoading.value = false;
                }
            } else {
                isLoading.value = false;
            }
        };

        postApi();

        // 下一頁
        const goNextPage = () => {
            if (store.state.eNotify.user.enotifyPromo.memberType === 'NON') {
                router.push({
                    name: routeName.ENOTIFY_SELECT_EMAIL
                });
            } else {
                router.push({
                    name: routeName.ENOTIFY_LOGIN
                });
            }
        };

        return {
            ...toRefs(users),
            goNextPage,
            postApi,
            isLoading
        };
    },
};
</script>
